import { PATH_NAME_SEARCH, PATH_NAME_SEARCH_TAG } from '@/common/resources/router.const'

export const SEARCH_THEME_LIST = 'theme-list'
export const LOG_SEND_LIST = [ PATH_NAME_SEARCH, PATH_NAME_SEARCH_TAG, SEARCH_THEME_LIST ]

export const LOG_V2_CURRENT = {
  EPISODE_LIST: 'episode_list',
  GN51: 'GN51',
  MOVIEPLUS_LIST: 'movieplus_list',
  MOVIE_LIST: 'movie_list',
  NO_RESULT: 'no_result',
  PROGRAM_LIST: 'program_list',
  RECOMMEND_LIST: 'recommend_list',
  RECOMMEND_RESULT: 'recommend_result',
  SEARCH_MAIN: 'search_main',
  SEARCH_RESULT: 'search_result',
  TAGSEARCH_EPISODE_LIST: 'tagsearch_episode_list',
  TAGSEARCH_MAIN_MOVIE: 'tagsearch_main_movie',
  TAGSEARCH_MAIN_VOD: 'tagsearch_main_vod',
  TAGSEARCH_MOVIEPLUS_LIST: 'tagsearch_movieplus_list',
  TAGSEARCH_MOVIE_LIST: 'tagsearch_movie_list',
  TAGSEARCH_PROGRAM_LIST: 'tagsearch_program_list',
  TAGSEARCH_RESULT: 'tagsearch_result',
  THEME_BAND_LIST: 'theme_band_list'
}

export const LOG_V2_ACTION_TYPE = {
  BUTTON_CLICK: 'button_click',
  CONTENT_CLICK: 'content_click',
  KEYWORD_CLICK: 'keyword_click',
  MENU_CLICK: 'menu_click',
  ORDER_BY: 'order_by',
  VIEW_MORE_CLICK: 'view_more_click'
}

export const LOG_V2_ACTION_ITEM = {
  AUTO_COMPLETION_KEYWORDS: 'auto_completion_keywords',
  BASEBALL_BAND: 'baseball_band',
  BASEBALL_BAND_VIEW_MORE: 'baseball_band_view_more',
  CATEGORY_BAND: 'category_band',
  CLOSE: 'close',
  EPISODE_BAND: 'episode_band',
  EPISODE_BAND_VIEW_MORE: 'episode_band_view_more',
  FIVE_GX_BAND: '5gx_band',
  FIVE_GX_BAND_VIEW_MORE: '5gx_band_view_more',
  GNB: 'gnb',
  LIVE_BAND: 'live_band',
  LIVE_BAND_VIEW_MORE: 'live_band_view_more',
  MOVIEPLUS_BAND: 'movieplus_band',
  MOVIEPLUS_BAND_VIEW_MORE: 'movieplus_band_view_more',
  MOVIE_BAND: 'movie_band',
  MOVIE_BAND_VIEW_MORE: 'movie_band_view_more',
  POPULAR_MOVIE_BAND: 'popular_movie_band',
  POPULAR_VOD_BAND: 'popular_vod_band',
  PROGRAM_BAND: 'program_band',
  PROGRAM_BAND_VIEW_MORE: 'program_band_view_more',
  RECOMMEND_KEYWORDS: 'recommend_keywords',
  RECOMMEND_MOVIE_LIST: 'recommend_movie_list',
  RECOMMEND_PROGRAM_LIST: 'recommend_program_list',
  SEARCH_MENU: 'search_menu',
  SEARCH_TEXT_CANCEL: 'search_text_cancel',
  TABBER: 'tabber',
  TAG_RESEARCH: 'tag_research',
  TAG_SELECT: 'tag_select',
  TAGSEARCH_MOVIE: 'tagsearch_movie',
  TAGSEARCH_VOD: 'tagsearch_vod',
  TEXT_SEARCH: 'text_search',
  TEXT_SEARCH_CANCEL: 'text_search_cancel',
  THEME_BAND: 'theme_band',
  THEME_BAND_VIEW_MORE: 'theme_band_view_more',
  THEME_MENU_VIEW_MORE: 'theme_menu_view_more'
}

export const LOG_V2_LANDING = {
  CONTENTS_DETAIL: 'contents_detail',
  GN_51: 'GN51',
  GN_52: 'GN52',
  GN_53: 'GN53',
  GN_54: 'GN54',
  SEARCH_MAIN: 'search_main',
  SEARCH_RESULT: 'search_result',
  TAGSEARCH_MAIN_MOVIE: 'tagsearch_main_movie',
  TAGSEARCH_MAIN_VOD: 'tagsearch_main_vod',
  TAGSEARCH_RESULT: 'tagsearch_result',
  THEME_LIST: 'theme_list'
}
